const PTSNavigationRoutes = {
  /** PTS login path; "/" is Schemas List (A1 home) inside PTS when authenticated */
  // ADMIN_LOGIN_PAGE: "/",

  /** PTS login path; "/home" is Schemas List (A1 home) inside PTS when authenticated */
  ADMIN_LOGIN_PAGE: "/pts-login",

  SSO_HANDOFF: "/sso-handoff",

  FORGOT_PASSWORD_RESET: (tokenId: string) =>
    `/forgot-password-reset/${tokenId}`,
  FORGOT_PASSWORD_RESET_ROUTE: "/forgot-password-reset/:tokenId",

  EMPLOYEE: "/employee",
  DESIGNATION_MASTER: "/designation-master",
  DASHBOARD: "/dashboard",
  EXECUTIVE_DASHBOARD: "/executive-dashboard",
  PROJECTS: "/projects",
  CHANGE_REQUESTS: "/change-requests",
  PURCHASE_APPROVALS: "/purchase-approvals",
  LEAVE_REQUESTS: "/leave-request",
  PROJECT_TEMPLATES: "/project-templates",
  SPRINT: "/sprint",
  SPRINT_TASK_ALLOCATION: "/sprint-task-allocation",
  TASKS: "/tasks",
  SERVICE_DESK_TASKS: "/service-desk-tasks",
  TASKS_WITH_FILTERS: (projectId?: string, statusId?: string) => {
    const params = new URLSearchParams();
    if (projectId) {
      params.set("project", projectId);
    }
    if (statusId) {
      params.set("status", statusId);
    }
    const queryString = params.toString();
    return queryString ? `/tasks?${queryString}` : "/tasks";
  },
  ATTENDANCE: "/attendance",
  MY_ATTENDANCE_REPORT: "/my-attendance-report",
  EMPLOYEE_CHECKIN: "/employee-checkin",
  SPENT_HOURS: "/spent-hours",
  DAILY_SPENT_HOURS: "/daily-spent-hours",
  REMAINING_TIME_REPORT: "/remaining-time-report",
  TODAYS_HOURS: "/todays-hours",
  EMPLOYEE_RATES: "/employee-rates",
  EMPLOYEE_DASHBOARD: "/employee-dashboard",

  // Settings Routes
  SETTINGS_LIST: "/settings-list",
  CREATE_SETTINGS: "/create-settings",
  EDIT_SETTINGS: (id: string) => `/edit-settings/${id}`,
  EDIT_SETTINGS_ROUTE: "/edit-settings/:id",

  // Employee Routes
  EMPLOYEE_PROFILE: "/employee/profile",
  CREATE_EMPLOYEE: "/employee/create",
  EDIT_EMPLOYEE: (id: string) => `/employee/edit/${id}`,
  EDIT_EMPLOYEE_ROUTE: "/employee/edit/:id",
  IMPORT_EMPLOYEE: "/employee/import",

  // Project Routes
  CREATE_PROJECT: "/project/create",
  EDIT_PROJECT: (id: string) => `/project/edit/${id}`,
  EDIT_PROJECT_ROUTE: "/project/edit/:id",
  IMPORT_PROJECT: "/project/import",

  ROLES_LIST: "/roles-permissions",
  ROLE_PERMISSION_MANAGER: "/role-permission-manager",
  // REPORTS: "/reports",
  PROJECT_SUMMARY: "/project-summary",
  BILLING_SUMMARY: "/billing-summary",
  EXPENSE_SUMMARY: "/expense-summary",
  EXPENSE_DASHBOARD: "/expense-dashboard",
  BILLING_INVOICE: "/billing/invoice",
  BILLING_INVOICE_REMINDERS: "/billing/invoice/reminders",
  BILLING_PROJECT_SETTING: "/billing/project-setting",
  NOTIFICATIONS: "/notifications",
  RESOURCE_ALLOCATION: "/resource-allocation",
  CHAT: "/chat",

  // Leave Application Routes
  LEAVE_APPLICATION: "/leave-application",
  CREATE_LEAVE_APPLICATION: "/leave-application/create",
  EDIT_LEAVE_APPLICATION: (id: string) => `/leave-application/edit/${id}`,
  EDIT_LEAVE_APPLICATION_ROUTE: "/leave-application/edit/:id",

  // Holiday List Routes
  HOLIDAY_LIST: "/holiday-list",
  CREATE_HOLIDAY: "/holiday-list/create",
  EDIT_HOLIDAY: (id: string) => `/holiday-list/edit/${id}`,
  EDIT_HOLIDAY_ROUTE: "/holiday-list/edit/:id",
  IMPORT_HOLIDAY: "/holiday-list/import",
};

export default PTSNavigationRoutes;
